import { Box, Container, Grid, Link, Stack, Typography } from '@mui/material';

const footerGroups = [
  {
    title: 'Learn',
    links: [
      { text: 'Courses', href: '/courses' },
    ],
  },
  {
    title: 'Practice',
    links: [
      { text: 'TopSWE100', href: '/problems' },
      { text: 'Quizzes', href: '/quizzes' },
      { text: 'Flashcards', href: '/flashcards' },
      { text: 'Roadmap', href: '/roadmap' },
    ],
  },
  {
    title: 'Product',
    links: [
      { text: 'Pricing', href: '/purchase' },
      { text: 'Profile', href: '/profile' },
      { text: 'Subscription', href: '/subscription' },
    ],
  },
  {
    title: 'Social',
    links: [
      { text: 'YouTube', href: 'https://youtube.com/@topswe', external: true },
      { text: 'Instagram', href: 'https://instagram.com/topswe', external: true },
      { text: 'LinkedIn', href: 'https://linkedin.com/in/topswe', external: true },
      { text: 'Newsletter', href: 'https://topswe.substack.com', external: true },
    ],
  },
];

function Footer() {
  return (
    <Box component="footer" sx={{ borderTop: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <Stack spacing={2} sx={{ maxWidth: 380 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box component="img" src="/topswe-logo.png" alt="TopSWE" sx={{ width: 32, height: 32, objectFit: 'contain' }} />
                <Typography variant="h6" sx={{ fontWeight: 800 }}>
                  TopSWE
                </Typography>
              </Box>
              <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                A structured coding interview prep system built around pattern recognition, curated practice, and active recall.
              </Typography>
              <Link href="mailto:topswebusiness@gmail.com" sx={{ color: 'text.primary', fontWeight: 700, textDecoration: 'none' }}>
                topswebusiness@gmail.com
              </Link>
            </Stack>
          </Grid>
          {footerGroups.map((group) => (
            <Grid item xs={6} sm={4} md={2} key={group.title}>
              <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 800 }}>
                {group.title}
              </Typography>
              <Stack spacing={1.2} sx={{ mt: 1.5 }}>
                {group.links.map((item) => (
                  <Link
                    key={item.text}
                    href={item.href}
                    target={item.external ? '_blank' : undefined}
                    rel={item.external ? 'noopener noreferrer' : undefined}
                    sx={{
                      color: 'text.primary',
                      textDecoration: 'none',
                      width: 'fit-content',
                      '&:hover': { color: 'primary.main' },
                    }}
                  >
                    {item.text}
                  </Link>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            mt: 6,
            pt: 3,
            borderTop: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            © 2026 TopSWE. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={2.5}>
            <Link href="/privacy" variant="body2" sx={{ color: 'text.secondary', textDecoration: 'none' }}>
              Privacy
            </Link>
            <Link href="/terms" variant="body2" sx={{ color: 'text.secondary', textDecoration: 'none' }}>
              Terms
            </Link>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
